import React from "react";
import {
  StyleSheet,
  View,
  StyleProp,
  ViewStyle,
  Text,
  TextStyle,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";
import { colors } from "src/assets";

const InActiveLayer = () => {
  return (
    <svg width="96" height="34" viewBox="0 0 96 34">
      <g transform="translate(-278 -480)">
        <rect
          width="96"
          height="34"
          rx="17"
          transform="translate(278 480)"
          fill="#a5a5a5"
        />
        <circle
          cx="15"
          cy="15"
          r="15"
          transform="translate(280 482)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

const ActiveLayer = () => {
  return (
    <svg width="96" height="34" viewBox="0 0 96 34">
      <g transform="translate(-278 -480)">
        <rect
          width="96"
          height="34"
          rx="17"
          transform="translate(278 480)"
          fill="#00e5e1"
        />
        <circle
          cx="15"
          cy="15"
          r="15"
          transform="translate(342 482)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export type FormControlSwitchProps = {
  containerStyle?: StyleProp<ViewStyle>;
  text: string;
  textStyle?: StyleProp<TextStyle>;
  activeText?: string;
  inActiveText?: string;
  value: boolean;
  error?: string;
  onChange?: (value?: boolean) => void;
};

export const FormControlSwitch: React.FC<FormControlSwitchProps> = ({
  containerStyle,
  text,
  textStyle,
  activeText,
  inActiveText,
  value,
  error,
  onChange,
}) => {
  return (
    <View style={[styles.container, containerStyle]}>
      <View style={styles.content}>
        <Text style={[styles.text, textStyle]}>{text}</Text>
        <View style={styles.rightContainer}>
          <TouchableOpacity onPress={() => (onChange ? onChange(!value) : {})}>
            {value ? (
              <React.Fragment>
                <ActiveLayer />
                <View style={styles.switchTextÇontainer}>
                  <Text style={styles.switchActiveText}>{activeText}</Text>
                </View>
              </React.Fragment>
            ) : null}
            {!value ? (
              <React.Fragment>
                <InActiveLayer />
                <View style={styles.switchTextÇontainer}>
                  <Text style={styles.switchInActiveText}>{inActiveText}</Text>
                </View>
              </React.Fragment>
            ) : null}
          </TouchableOpacity>
        </View>
      </View>
      {error ? <Text style={styles.error}>{error}</Text> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    flexDirection: "column",
  },
  content: {
    flexDirection: "row",
    alignItems: "center",
  },
  text: {
    flex: 1,
    color: colors.chokuGray,
    fontSize: 14,
    textAlign: "right",
    marginRight: 16,
  },
  rightContainer: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  error: {
    color: colors.chokuRed,
  },
  switchTextÇontainer: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  switchActiveText: {
    marginRight: 20,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    color: colors.white,
  },
  switchInActiveText: {
    marginLeft: 20,
    fontSize: 12,
    fontWeight: "bold",
    color: colors.white,
  },
});
